import type { GeoJSONSource, Map } from 'maplibre-gl';
import type { FeatureCollection, GeoJSON } from 'geojson';

export const EMPTY_FEATURE_COLLECTION: FeatureCollection = {
    type: 'FeatureCollection',
    features: [],
};

/** Safe GeoJSON source update — no-op when the map or source is gone. */
export function setGeoJsonSourceData(map: Map, id: string, data: GeoJSON): boolean {
    if (!map.style) {
        return false;
    }

    const source = map.getSource(id) as GeoJSONSource | undefined;

    if (!source) {
        return false;
    }

    source.setData(data);
    return true;
}
